import { ButtonV3, TypographyV3 } from '@jouzen/ecom-components';
import { useTranslations } from 'next-intl';

import SizingPageSection from './SizingPageSection';

const ConfirmSizeSection = (): JSX.Element => {
  const t = useTranslations();

  return (
    <SizingPageSection
      data-cy="confirm-size-section"
      heading={{ content: 'confirm_your_size' }}
    >
      <TypographyV3 className="text-lg">
        {t.rich('sizing_gen4_confirm_size_content')}
      </TypographyV3>
      <ButtonV3 href="/my-account" size="large" variant="secondary-dark">
        {t('confirm_your_size')}
      </ButtonV3>
    </SizingPageSection>
  );
};

export default ConfirmSizeSection;
